import axios from "axios";
import React, { useState, useCallback, useEffect } from "react";
// import UserLayout from "@components/user/Layouts";
import cn from "classnames";
import { Avatar, Empty, Modal, Skeleton, Tabs } from "antd";
// import PointBalance from "@components/user/PointBalance";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import moment from "moment";
import { useSelector } from "react-redux";
import PointBalance from "./PointBalance/PointBalance";
import { useLocation } from "react-router";
import { getParamValue } from "../../../utils";
// import rangeMap from "@lib/range-map";
// import ConvertPoint from "@components/user/PointBalance/ConvertPoint";
// import { useDetails } from "@lib/hooks/useDetails";

// export async function getStaticProps({
//   preview,
//   locale,
//   locales,
// }: GetStaticPropsContext) {
//   const config = { locale, locales }
//   const pagesPromise = commerce.getAllPages({ config, preview })
//   const siteInfoPromise = commerce.getSiteInfo({ config, preview })
//   const { pages } = await pagesPromise
//   const { categories } = await siteInfoPromise

//   return {
//     props: { pages, categories },
//   }
// }

export default function Balance() {
  const { token, merchantInfo } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);
  // const { page = 0, limit = 3 } = router.query;
  const [pageNumber, setPageNumber] = useState<any>(page);
  const [visibleModal, setVisibleModal] = useState(false);
  // const { getUserDetails } = useDetails();

  const [balanceData, setBalanceData] = useState<{
    loading: boolean;
    data: any;
  }>();
  const [inactivePoint, setInactivePoint] = useState<{
    loading: boolean;
    data: any;
  }>();
  const [activePoint, setActivePoint] = useState<{
    loading: boolean;
    data: any;
  }>();
  // status (EARNED, REDEEMED, EXPIRED) point-history
  const [status, setStatus] = useState("");
  const [inactiveStatus, setInactiveStatus] = useState("EARNED");
  const [activeStatus, setActiveStatus] = useState("EARNED");

  const getUserBalance = useCallback(async () => {
    try {
      setBalanceData({ loading: true, data: null });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/transaction-history?page=${pageNumber}&limit=${limit}` +
          (status ? `&type=${status}` : ``),
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setBalanceData({ loading: false, data: res.data });
      } else {
        setBalanceData({ loading: false, data: null });
      }
    } catch (e) {
      setBalanceData({ loading: false, data: null });
      console.error("Order:", e);
    }
  }, [token, limit, status]);

  const getInactivePoint = useCallback(async () => {
    try {
      setInactivePoint({ loading: true, data: null });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/point-history?page=${pageNumber}&limit=${limit}&isActive=false` +
          (inactiveStatus ? `&status=${inactiveStatus}` : ``),
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setInactivePoint({ loading: false, data: res.data });
      } else {
        setInactivePoint({ loading: false, data: null });
      }
    } catch (e) {
      setInactivePoint({ loading: false, data: null });
      console.error("Order:", e);
    }
  }, [token, page, limit, inactiveStatus]);

  const getActivePoint = useCallback(async () => {
    try {
      setActivePoint({ loading: true, data: null });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/point-history?page=${pageNumber}&limit=${limit}&isActive=true` +
          (activeStatus ? `&status=${activeStatus}` : ``),
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setActivePoint({ loading: false, data: res.data });
      } else {
        setActivePoint({ loading: false, data: null });
      }
    } catch (e) {
      setActivePoint({ loading: false, data: null });
      console.error("Order:", e);
    }
  }, [token, limit, activeStatus]);

  useEffect(() => {
    setPageNumber(0);
  }, [status]);

  useEffect(() => {
    if (page) {
      setPageNumber(page);
    }
  }, [page]);

  useEffect(() => {
    getInactivePoint();
  }, [getInactivePoint]);

  useEffect(() => {
    getActivePoint();
  }, [getActivePoint]);

  useEffect(() => {
    getUserBalance();
  }, [getUserBalance]);

  // useEffect(() => {
  //   getUserDetails();
  // }, [getUserDetails]);

  const refetch = () => {
    setVisibleModal(false);
    getActivePoint();
    // getUserDetails();
  };
  // title="My Points/Balance"

  return (
    <>
  
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-8">
          <PointBalance
            balanceData={{
              title: "Balance",
              icon: "/wallet.png",
              balance: `BDT ${merchantInfo?.balance || 0}`,
            }}
          >
            <div className="">
              <Tabs onChange={(val) => setStatus(val)} defaultActiveKey="">
                <TabPane key="" tab={<span className="px-4">All</span>}>
                  <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                    <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                      <span>Balance History </span>
                      <span>BDT</span>
                    </div>
                    <div className="w-full">
                      {!balanceData?.loading ? (
                        balanceData?.data?.transactions?.length ? (
                          balanceData?.data?.transactions?.map(
                            (point: any, i: string) => (
                              <div
                                className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                                key={i}
                              >
                                <div className="flex flex-col">
                                  <div className="font-semibold">
                                    {point?.description}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    Exp:{" "}
                                    {moment(point?.pointExpiration).format(
                                      "ll"
                                    )}
                                  </span>
                                </div>
                                <div className="flex flex-col text-right">
                                  <span
                                    className={cn(
                                      "text-gray-600 font-semibold"
                                    )}
                                  >
                                    {point?.type === "ADD" ? (
                                      <span className="text-red-600">
                                        + &#2547;{point?.amount}
                                      </span>
                                    ) : (
                                      <span className="text-gray-900">
                                        - &#2547;{point?.amount}
                                      </span>
                                    )}
                                  </span>
                                  <span className={cn("text-gray-500 text-sm")}>
                                    Balance &#2547;{point?.currentBalance || 0}
                                  </span>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <Empty />
                        )
                      ) : (
                        <Skeleton>
                          <div className="w-full h-14 mt-2" />
                        </Skeleton>
                      )}
                    </div>
                  </div>
                </TabPane>
                <TabPane key="ADD" tab="+ Incoming">
                  <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                    <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                      <span>Balance History</span>
                      <span>BDT</span>
                    </div>
                    <div className="w-full">
                      {!balanceData?.loading ? (
                        balanceData?.data?.transactions?.length ? (
                          balanceData?.data?.transactions?.map(
                            (point: any, i: string) => (
                              <div
                                className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                                key={i}
                              >
                                <div className="flex flex-col">
                                  <div className="font-semibold">
                                    {point?.description}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    Exp:{" "}
                                    {moment(point?.pointExpiration).format(
                                      "ll"
                                    )}
                                  </span>
                                </div>
                                <div className="flex flex-col text-right">
                                  <span
                                    className={cn(
                                      "text-gray-600 font-semibold"
                                    )}
                                  >
                                    {point?.type === "ADD" ? (
                                      <span className="text-red-500">
                                        + &#2547;{point?.amount}
                                      </span>
                                    ) : (
                                      <span className="text-gray-900">
                                        - &#2547;{point?.amount}
                                      </span>
                                    )}
                                  </span>
                                  <span className={cn("text-gray-500 text-sm")}>
                                    Balance &#2547;{point?.currentBalance || 0}
                                  </span>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <Empty />
                        )
                      ) : (
                        <Skeleton>
                          <div className="w-full h-14 mt-2" />
                        </Skeleton>
                      )}
                    </div>
                  </div>
                </TabPane>
                <TabPane key="SUBTRACT" tab="- Outcoming">
                  <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                    <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                      <span>Balance History</span>
                      <span>BDT</span>
                    </div>
                    <div className="w-full">
                      {!balanceData?.loading ? (
                        balanceData?.data?.transactions?.length ? (
                          balanceData?.data?.transactions?.map(
                            (point: any, i: string) => (
                              <div
                                className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                                key={i}
                              >
                                <div className="flex flex-col">
                                  <div className="font-semibold">
                                    {point?.description}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    Exp:{" "}
                                    {moment(point?.pointExpiration).format(
                                      "ll"
                                    )}
                                  </span>
                                </div>
                                <div className="flex flex-col text-right">
                                  <span
                                    className={cn(
                                      "text-gray-600 font-semibold"
                                    )}
                                  >
                                    {point?.type === "SUBSTACT" ? (
                                      <span className="text-red-600">
                                        + &#2547;{point?.amount}
                                      </span>
                                    ) : (
                                      <span className="text-gray-900">
                                        - &#2547;{point?.amount}
                                      </span>
                                    )}
                                  </span>
                                  <span className={cn("text-gray-500 text-sm")}>
                                    Balance &#2547;{point?.currentBalance || 0}
                                  </span>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <Empty />
                        )
                      ) : (
                        <Skeleton>
                          <div className="w-full h-14 mt-2" />
                        </Skeleton>
                      )}
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </PointBalance>

          <PointBalance
            dissaled
            balanceData={{
              title: "Inactive Point",
              icon: "/coin-dissabled.png",
              balance: `Point ${merchantInfo?.inActivePoints || 0}`,
            }}
          >
            <Tabs
              onChange={(val) => setInactiveStatus(val)}
              defaultActiveKey="EARNED"
            >
              <TabPane key="EARNED" tab="Earned">
                <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                  <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                    <span>Earned Details</span>
                    <span>Points</span>
                  </div>
                  <div className="w-full">
                    {!inactivePoint?.loading ? (
                      inactivePoint?.data?.pointsHistories?.length ? (
                        inactivePoint?.data?.pointsHistories?.map(
                          (point: any, i: string) => (
                            <div
                              className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                              key={i}
                            >
                              <div className="flex flex-col">
                                <div className="font-semibold">
                                  {point?.reasonForGettingPoint}
                                </div>
                                <span className="text-sm text-gray-500">
                                  {moment(point?.createdAt).format("ll")}
                                </span>
                                {/* <span className="text-sm text-gray-500">
                                  <span className="font-semibold">Exp:</span>{' '}
                                  {moment(point?.pointExpiration).format('ll')}
                                </span> */}
                              </div>
                              <div className="flex flex-col text-right">
                                <span
                                  className={cn("text-gray-600 font-semibold")}
                                >
                                  {point?.pointsAmount}
                                </span>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <Empty />
                      )
                    ) : (
                      <Skeleton>
                        <div className="w-full h-14 mt-2" />
                      </Skeleton>
                    )}
                  </div>
                </div>
              </TabPane>
              <TabPane key="EXPIRED" tab="Expired">
                <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                  <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                    <span>Earned Details</span>
                    <span>Points</span>
                  </div>
                  <div className="w-full">
                    {!inactivePoint?.loading ? (
                      inactivePoint?.data?.transactions?.length ? (
                        inactivePoint?.data?.transactions?.map(
                          (point: any, i: string) => (
                            <div
                              className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                              key={i}
                            >
                              <div className="flex flex-col">
                                <div className="font-semibold">
                                  {point?.reasonForGettingPoint}
                                </div>
                                <span className="text-sm text-gray-500">
                                  Exp:{" "}
                                  {moment(point?.pointExpiration).format("lll")}
                                </span>
                              </div>
                              <div className="flex flex-col text-right">
                                <span
                                  className={cn("text-gray-600 font-semibold")}
                                >
                                  {point?.pointsAmount}
                                </span>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <Empty />
                      )
                    ) : (
                      <Skeleton>
                        <div className="w-full h-14 mt-2" />
                      </Skeleton>
                    )}
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </PointBalance>

          <PointBalance
            balanceData={{
              title: "Active Point",
              icon: "/coin.png",
              balance: `Point ${merchantInfo?.activePoints || 0}`,
            }}
            extra={
              ""
              // <span
              //   className="rounded-full p-3 border font-semibold flex gap-2 cursor-pointer"
              //   style={{
              //     borderColor: "#EAA92A",
              //     background: "#F4ECCE",
              //   }}
              //   onClick={() => setVisibleModal(!visibleModal)}
              // >
              //   <Avatar src={"/wallet.png"} alt="jachai.com" />
              //   Convert to
              //   <svg
              //     width="17"
              //     height="18"
              //     viewBox="0 0 17 18"
              //     fill="none"
              //     xmlns="http://www.w3.org/2000/svg"
              //   >
              //     <g clipPath="url(#clip0_15474_76702)">
              //       <path
              //         d="M16.4988 13.5C16.4988 15.982 14.4809 18 11.9988 18H4.5C2.01797 18 0 15.982 0 13.5C0 9.46406 3.42773 4.40859 7.46016 3.81094C6.73242 3.12891 5.70234 2.04258 5.29102 1.00195C5.09766 0.520312 5.48438 0 6.00117 0H10.5012C11.018 0 11.4012 0.520312 11.2113 1.00195C10.8 2.03906 9.76992 3.12891 9.04219 3.81094C13.0746 4.40859 16.4988 9.46406 16.4988 13.5Z"
              //         fill="#8A4545"
              //       />
              //       <path
              //         d="M6.79609 11.4433C6.77852 11.4433 6.76445 11.4433 6.75039 11.4433C6.46914 11.4433 6.18789 11.4433 5.90664 11.4433C5.88906 11.4433 5.87148 11.4363 5.85742 11.4222C5.57617 11.1304 5.29492 10.8351 5.01367 10.5433C5.01016 10.5363 5.00312 10.5328 4.99609 10.5222C5.60078 10.5222 6.19492 10.5222 6.79609 10.5222C6.79609 10.5082 6.79609 10.4976 6.79609 10.4871C6.79609 9.88941 6.79609 9.29527 6.79609 8.69761C6.79609 8.52886 6.75039 8.37417 6.62734 8.25113C6.53594 8.16323 6.42344 8.11402 6.30391 8.07886C6.15625 8.03316 6.00859 8.03316 5.86094 8.07183C5.81172 8.08589 5.76602 8.1105 5.71328 8.13159C5.68867 8.08941 5.66055 8.0437 5.63594 7.99097C5.55508 7.81519 5.4707 7.64292 5.40391 7.46363C5.36875 7.37222 5.38984 7.27378 5.44258 7.18589C5.50586 7.08394 5.60078 7.01714 5.70625 6.96441C5.90664 6.86245 6.11758 6.78511 6.34258 6.76402C6.75391 6.72183 7.09141 6.85542 7.34453 7.19292C7.55898 7.47769 7.67148 7.80113 7.72422 8.14917C7.74883 8.31441 7.75937 8.48316 7.75937 8.65191C7.75937 9.26011 7.75937 9.8648 7.75937 10.473C7.75937 10.4871 7.75937 10.5046 7.75937 10.5187C7.77695 10.5187 7.7875 10.5187 7.79805 10.5187C7.95625 10.5187 8.11094 10.5187 8.26914 10.5187C8.2832 10.5187 8.30078 10.5257 8.31133 10.5363C8.60312 10.8316 8.89141 11.1269 9.17969 11.4222C9.1832 11.4257 9.18672 11.4292 9.19375 11.4398C8.71211 11.4398 8.2375 11.4398 7.75937 11.4398C7.75937 11.4539 7.75586 11.4679 7.75586 11.4785C7.75586 12.3328 7.75586 13.1871 7.75586 14.0414C7.75586 14.3261 7.87891 14.5476 8.10742 14.7128C8.22344 14.7937 8.35703 14.8253 8.49766 14.8464C8.90547 14.9062 9.27109 14.7937 9.60508 14.5687C10.0445 14.2734 10.4102 13.9007 10.6809 13.4437C10.818 13.2117 10.9129 12.9621 10.948 12.6949C10.9551 12.6492 10.9586 12.6 10.9621 12.5543C10.9621 12.5507 10.9621 12.5472 10.9621 12.5367C10.9164 12.5402 10.8672 12.5437 10.8215 12.5472C10.5859 12.5648 10.3539 12.5402 10.1359 12.4488C9.88984 12.3468 9.71406 12.1675 9.61914 11.9179C9.49961 11.6015 9.46445 11.271 9.54531 10.9406C9.60508 10.691 9.73516 10.48 9.94258 10.3253C10.0797 10.2234 10.2414 10.1707 10.4102 10.1425C10.6422 10.1039 10.8707 10.1003 11.0992 10.1531C11.3488 10.2128 11.5668 10.3359 11.7496 10.5152C12.1082 10.8632 12.3297 11.2851 12.407 11.7773C12.502 12.3855 12.407 12.9691 12.1539 13.5281C11.9641 13.9464 11.7004 14.3156 11.391 14.6566C11.1801 14.8921 10.9516 15.1066 10.6949 15.2894C10.3258 15.5496 9.925 15.7359 9.48203 15.8343C9.23594 15.8906 8.98633 15.9152 8.7332 15.9152C8.49414 15.9152 8.26562 15.8554 8.05117 15.7535C7.63281 15.5566 7.28477 15.2718 7.00703 14.8992C6.91914 14.7796 6.84883 14.6496 6.81016 14.5054C6.80312 14.4843 6.79961 14.4597 6.79961 14.4351C6.79961 13.4507 6.79961 12.4664 6.79961 11.482C6.79609 11.4785 6.79609 11.4644 6.79609 11.4433Z"
              //         fill="white"
              //       />
              //       <path
              //         d="M12.4409 17.1105C12.2933 17.1105 12.1526 17.0156 12.1069 16.8644C12.0472 16.6781 12.1491 16.4812 12.3354 16.4215C13.2425 16.1332 13.9245 15.5848 14.3675 14.7937C14.7015 14.1926 14.7647 13.6652 14.7647 13.6582C14.7858 13.4648 14.9616 13.3277 15.1515 13.3488C15.3448 13.3699 15.4819 13.5422 15.4608 13.7355C15.4573 13.7601 15.387 14.3859 14.9933 15.1066C14.6312 15.7711 13.9104 16.657 12.5464 17.093C12.5147 17.107 12.4761 17.1105 12.4409 17.1105Z"
              //         fill="white"
              //       />
              //     </g>
              //     <defs>
              //       <clipPath id="clip0_15474_76702">
              //         <rect width="16.4988" height="18" fill="white" />
              //       </clipPath>
              //     </defs>
              //   </svg>
              // </span>
            }
          >
            <div className="">
              <Tabs
                onChange={(val) => setActiveStatus(val)}
                defaultActiveKey="EARNED"
              >
                <TabPane key="EARNED" tab="Earned">
                  <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                    <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-4">
                      <span>Earned Details</span>
                      <span>Points</span>
                    </div>
                    <div className="w-full">
                      {!activePoint?.loading ? (
                        activePoint?.data?.pointsHistories?.length ? (
                          activePoint?.data?.pointsHistories?.map(
                            (point: any, i: string) => (
                              <div
                                className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                                key={i}
                              >
                                <div className="flex flex-col">
                                  <div className="font-semibold">
                                    {point?.reasonForGettingPoint}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    {moment(point?.createdAt).format("ll")}
                                  </span>
                                  <span className="text-sm text-gray-500">
                                    <span className="font-semibold">Exp:</span>{" "}
                                    {moment(point?.pointExpiration).format(
                                      "ll"
                                    )}
                                  </span>
                                </div>
                                <div className="flex flex-col text-right">
                                  <span
                                    className={cn(
                                      "text-gray-600 font-semibold"
                                    )}
                                  >
                                    {point?.pointsAmount}
                                  </span>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <Empty />
                        )
                      ) : (
                        <Skeleton>
                          <div className="w-full h-14 mt-2" />
                        </Skeleton>
                      )}
                    </div>
                  </div>
                </TabPane>
                <TabPane key="REDEEMED" tab="Redeemed">
                  <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                    <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                      <span>Earned Details</span>
                      <span>Points</span>
                    </div>
                    <div className="w-full">
                      {!activePoint?.loading ? (
                        activePoint?.data?.pointsHistories?.length ? (
                          activePoint?.data?.pointsHistories?.map(
                            (point: any, i: string) => (
                              <div
                                className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                                key={i}
                              >
                                <div className="flex flex-col">
                                  <div className="font-semibold">
                                    {point?.reasonForGettingPoint}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    {moment(point?.createdAt).format("ll")}
                                  </span>
                                  <span className="text-sm text-gray-500">
                                    <span className="font-semibold">Exp:</span>{" "}
                                    {moment(point?.pointExpiration).format(
                                      "ll"
                                    )}
                                  </span>
                                </div>
                                <div className="flex flex-col text-right">
                                  <span
                                    className={cn(
                                      "text-gray-600 font-semibold"
                                    )}
                                  >
                                    {point?.pointsAmount}
                                  </span>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <Empty />
                        )
                      ) : (
                        <Skeleton>
                          <div className="w-full h-14 mt-2" />
                        </Skeleton>
                      )}
                    </div>
                  </div>
                </TabPane>
                <TabPane key="EXPIRED" tab="Expired">
                  <div className="rounded-b-xl flex justify-between items-center flex-wrap">
                    <div className="flex justify-between items-baseline gap-4 pb-2 w-full font-semibold text-gray-500">
                      <span>Earned Details</span>
                      <span>Points</span>
                    </div>
                    <div className="w-full">
                      {!activePoint?.loading ? (
                        activePoint?.data?.pointsHistories?.length ? (
                          activePoint?.data?.pointsHistories?.map(
                            (point: any, i: string) => (
                              <div
                                className="flex justify-between items-baseline gap-4 py-2 border-t w-full"
                                key={i}
                              >
                                <div className="flex flex-col">
                                  <div className="font-semibold">
                                    {point?.reasonForGettingPoint}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    {moment(point?.createdAt).format("ll")}
                                  </span>
                                  <span className="text-sm text-gray-500">
                                    <span className="font-semibold">Exp:</span>{" "}
                                    {moment(point?.pointExpiration).format(
                                      "ll"
                                    )}
                                  </span>
                                </div>
                                <div className="flex flex-col text-right">
                                  <span
                                    className={cn(
                                      "text-gray-600 font-semibold"
                                    )}
                                  >
                                    {point?.pointsAmount}
                                  </span>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <Empty />
                        )
                      ) : (
                        <Skeleton>
                          <div className="w-full h-14 mt-2" />
                        </Skeleton>
                      )}
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </PointBalance>
        </div>

        <Modal
          open={visibleModal}
          onCancel={() => setVisibleModal(!visibleModal)}
          width={400}
          title={
            <span className="flex gap-4 justify-center font-semibold">
              <span>Points</span>
              <span className="text-red-500">
                {merchantInfo?.activePoints || 0}
              </span>
            </span>
          }
        >
          {/* <ConvertPoint refetch={refetch} /> */}
        </Modal>
    
    </>
  );
}
